export default __webpack_public_path__ + "static/media/icon2.f80e4ca6.jpeg";